import React, { useState } from 'react';
import { IconRefresh, IconCheck } from './Icons';

function Dot({ ok }) {
  const color = ok ? '#22c55e' : '#ef4444';
  return <span style={{ width: 9, height: 9, borderRadius: '50%', background: color, display: 'inline-block', marginRight: 6, flex: '0 0 auto' }} />;
}

export default function JobPanel({ job, onCancel }) {
  const [tab, setTab] = useState('riepilogo');
  const pct = job.total > 0 ? Math.round((job.completed / job.total) * 100) : 0;
  const perLine = Array.isArray(job.per_line) ? job.per_line : [];
  const vel = job.velocita_min;
  const lineeAttive = perLine.reduce((s, l) => s + (l.registrati || 0), 0);
  const activeLineIdx = tab.startsWith('l') ? Number(tab.slice(1)) : -1;
  const activeLine = activeLineIdx >= 0 ? perLine[activeLineIdx] : null;

  // ETA del lotto corrente: (rimanenti) / velocità
  const rimanenti = Math.max(0, (job.total || 0) - (job.completed || 0));
  const etaMin = vel && vel > 0 ? Math.round(rimanenti / vel) : null;

  const tabBtn = (id, label) => (
    <button
      onClick={() => setTab(id)}
      style={{
        padding: '6px 12px', fontSize: 12, fontWeight: 600, border: 'none',
        borderBottom: tab === id ? '2px solid #2563eb' : '2px solid transparent',
        background: 'none', color: tab === id ? '#2563eb' : '#64748b', cursor: 'pointer',
      }}
    >{label}</button>
  );

  return (
    <div className="job-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <strong style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <IconRefresh size={16} /> Verifica in corso
        </strong>
        <button className="btn btn-danger" onClick={onCancel}>Annulla</button>
      </div>

      {/* Tab bar */}
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e2e8f0', marginBottom: 10, flexWrap: 'wrap' }}>
        {tabBtn('riepilogo', 'Riepilogo')}
        {perLine.map((l, i) => tabBtn(`l${i}`, l.nome || l.server))}
      </div>

      {tab === 'riepilogo' && (
        <div>
          <div style={{ fontSize: 12, color: '#475569', marginBottom: 6 }}>
            {job.completed} / {job.total} ({pct}%)
            {vel != null && <span style={{ marginLeft: 12 }}>· {vel}/min</span>}
            {etaMin != null && <span style={{ marginLeft: 12 }}>· ETA ~{etaMin} min</span>}
            <span style={{ marginLeft: 12 }}>· linee attive: {lineeAttive}</span>
          </div>
          <div className="progress-bar"><div className="fill" style={{ width: `${pct}%` }} /></div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#475569' }}>
            <IconCheck size={12} style={{ verticalAlign: 'middle' }} /> TIM: {job.tim_count || 0} · NON TIM: {job.non_tim_count || 0} · errori: {job.errors || 0}
          </div>
          {/* Una linea disattivata mentre il lotto girava: il lotto rallenta, e questo
              dice perché. Il numero che aveva in mano è stato completato. */}
          {(job.linee_fermate || []).map((f, i) => (
            <div key={`f${i}`} style={{ marginTop: 8, fontSize: 12, color: '#b45309' }}>
              Linea <strong>{f.nome}</strong> disattivata: ha finito il numero in corso e si è chiusa.
            </div>
          ))}
          {perLine.length > 0 && (
            <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
              {perLine.map((l, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: 12, color: '#475569' }}>
                  <Dot ok={(l.registrati || 0) > 0} />
                  <strong style={{ minWidth: 120 }}>{l.nome || l.server}</strong>
                  <span style={{ marginLeft: 8, color: '#94a3b8' }}>{l.registrati}/{l.totali} interni</span>
                  <span style={{ marginLeft: 12 }}>{l.completati || 0} fatti</span>
                  <span style={{ marginLeft: 12 }}>→ {l.numero_corrente || '—'}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeLine && (
        <div style={{ fontSize: 13, color: '#334155' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <Dot ok={(activeLine.registrati || 0) > 0} />
            <strong>{activeLine.nome || activeLine.server}</strong>
            <span style={{ marginLeft: 8, color: '#94a3b8' }}>({activeLine.registrati}/{activeLine.totali} interni registrati)</span>
          </div>
          <div style={{ marginBottom: 6 }}>Sto chiamando: <strong>{activeLine.numero_corrente || '—'}</strong></div>
          <div>
            Completati: <strong>{activeLine.completati || 0}</strong>
            <span style={{ marginLeft: 12 }}>TIM: {activeLine.tim || 0}</span>
            <span style={{ marginLeft: 12 }}>NON TIM: {activeLine.non_tim || 0}</span>
            <span style={{ marginLeft: 12 }}>errori: {activeLine.errori || 0}</span>
          </div>
          <div style={{ marginTop: 6, color: '#64748b' }}>
            Velocità: {activeLine.velocita_min != null ? `${activeLine.velocita_min}/min` : '—'}
          </div>
        </div>
      )}
    </div>
  );
}
